import { useCallback, useEffect, useState } from "react";
import { useParams, useNavigate } from "react-router-dom";
import "./tags.css";
import ApiRequest from "../../helper/ApiRequest";
import { ApiEndpoints } from "../../helper/ApiEndpoints";

const tagEditEndpoint = ApiEndpoints.tags.tagEdit;
const tagUpdateEndPoint = ApiEndpoints.tags.tagUpdate;

export default function EditTags() {
  const { tags_id } = useParams();
  const [data, setData] = useState({ name: "" });
  const navigate = useNavigate();
  
  useEffect(() => {
    const dataFetch = async () => {
      try {
        const response = await ApiRequest(
          "GET",
          `${tagEditEndpoint}${tags_id}`
        );
        const result = response.tag;
        setData(result);
      } catch (error) {
        console.log(error);
      }
    };
    dataFetch();
  }, [tags_id]);

  const handleInputChange = useCallback((e) => {
    const { name, value } = e.target;
    setData((prevData) => ({
      ...prevData,
      [name]: value,
    }));
  }, []);

  const handleSubmit = useCallback(
    async (event) => {
      event.preventDefault();
      const payload = {
        tag_id: tags_id,
        name: data.name,
      };

      try {
        await ApiRequest("POST", tagUpdateEndPoint, payload);
        navigate("/admin/tags");
      } catch (error) {
        console.error("Error updating tag data:", error);
        alert("There was an error updating the tag!");
      }
    },
    [tags_id, data.name, navigate]
  );
  
  return (
    <>
      <div className="header-add-category">
        <h5>Edit Tags</h5>
      </div>
      <div className="add-tag-content">
        <form onSubmit={handleSubmit}>
          <label>Name:</label>
          <input
            name="name"
            value={data.name}
            type="text"
            className="form-control"
            onChange={handleInputChange}
            required
          />
          <div className="submit-formbtn">
            <button type="submit" className="default-btn">
              Save Changes
            </button>
          </div>
        </form>
      </div>
    </>
  );
}
